import React, { useState } from "react";
import styled, { keyframes } from "styled-components";
import {
  CautionIcon,
  CloseIcon,
  DeleteIcon,
  MarkedIcon,
} from "../../../../components/svgs";
import ConfirmModal from "./ConfirmModal";

const OptionsModal = ({
  isOpen,
  onClose,
  onDeleteSelected,
  onMarkSelectedAsViewed,
}) => {
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  if (!isOpen) return null;

  return (
    <ModalOverlay onClick={onClose}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <ModalBorder>
          <ModalHead>
            <ModalTitle>Select action</ModalTitle>
            <CloseIcon onClick={onClose} />
          </ModalHead>
          <HorizontalLine />
          <ActionList>
            <ActionListContainer
              onClick={() => {
                onMarkSelectedAsViewed();
                onClose();
              }}
            >
              <MarkedIcon />
              <OptionItem>Mark all as read</OptionItem>
            </ActionListContainer>
            <ActionListContainer onClick={() => setShowConfirmModal(true)}>
              <DeleteIcon />
              <OptionItem style={{ color: "#dc0000" }}>
                Delete selected
              </OptionItem>
            </ActionListContainer>
          </ActionList>
        </ModalBorder>
      </ModalContent>
      {showConfirmModal && (
        <ConfirmModal
          isOpen={showConfirmModal}
          onClose={() => setShowConfirmModal(false)}
          title="Delete notifications?"
          message=""
          icon={
            <CautionIcon fill="white" stroke="#333" width="90" height="90" />
          }
          onConfirm={() => {
            onDeleteSelected();
            setShowConfirmModal(false);
            onClose();
          }}
        />
      )}
    </ModalOverlay>
  );
};

OptionsModal.defaultProps = {
  handleMarkSelectedAsViewed: () => console.warn("Function not provided"),
};

export default OptionsModal;

const slideUp = keyframes`
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
`;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: flex-end;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background: white;
  border-radius: 16px 0 0 0;
  width: 100%;
  max-width: 480px;
  position: relative;
  text-align: center;
  animation: ${slideUp} 0.3s ease-out;
`;

const ModalBorder = styled.div`
  padding: 20px;
`;

const ModalTitle = styled.h2`
  margin: 0 0 10px;
  font-size: 15px;
  text-align: left;
  font-family: "MTNBold";
`;

const HorizontalLine = styled.hr`
  width: 100%;
  border: none;
  border-top: 1px solid #cccccc;
  margin: 10px 0;
`;

const ActionList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-family: MTNRegular;
`;

const ModalHead = styled.div`
  display: flex;
  justify-content: space-between;
`;

const ActionListContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  cursor: pointer;
  padding: 10px 0;
  width: 100%;

  &:hover {
    background: #f5f5f5;
  }
`;

const OptionItem = styled.span`
  font-size: 16px;
  font-weight: 600;
`;
